import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { exportToExcel } from '../utils/exportExcel';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: '20px',
        textAlign: 'center'
    }
}));

const Excel = ({ url }) => {
    const classes = useStyles();

    const handleDownload = () => {
        const columns = [
            { label: "Sucursal", value: "sucursal" },
            { label: "Vehiculo", value: "vehiculo" },
            { label: "Combustible", value: "combustible" },
            { label: "Litros", value: "litros" },
            { label: "Importe", value: "importe" },
            { label: "Fecha de carga", value: "fecha" },
        ];
        exportToExcel(url, "Combustibles", "Employees", columns);
    };

    return (
        <Paper className={classes.root}>
            <Button variant="contained" color="primary" onClick={handleDownload}>
                Descargar Excel
            </Button>
        </Paper>
    );
}

export default Excel;
